var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("hr", { staticClass: "emd-divider" }),
    _c("div", { staticClass: "eu-pa_3 eu-pa_5_md" }, [
      _c("div", { staticClass: "eu-flex eu-pb_5" }, [
        _c(
          "span",
          {
            staticClass:
              "summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_2",
          },
          [_vm._v(_vm._s(_vm.$t("linkName")))]
        ),
        _c(
          "span",
          {
            staticClass:
              "summary-content eu-flex-item eu-basis_12 eu-basis_12_md",
          },
          [_vm._v(_vm._s(_vm.paymentLinkData.name || "-"))]
        ),
      ]),
      _c("div", { staticClass: "eu-flex eu-pb_5" }, [
        _c(
          "span",
          {
            staticClass:
              "summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_2",
          },
          [_vm._v(_vm._s(_vm.$t("expirationTime")))]
        ),
        _c(
          "span",
          {
            staticClass:
              "summary-content eu-flex-item eu-basis_12 eu-basis_12_md",
          },
          [_vm._v(_vm._s(_vm.expiresIn))]
        ),
      ]),
      _c("div", { staticClass: "eu-flex" }, [
        _c(
          "span",
          {
            staticClass:
              "summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_2",
          },
          [_vm._v(_vm._s(_vm.$t("paymentLimit")))]
        ),
        _c(
          "span",
          {
            staticClass:
              "summary-content eu-flex-item eu-basis_12 eu-basis_12_md",
          },
          [_vm._v(_vm._s(_vm.paymentLinkData.max_paid_sessions || "-"))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }